import { Linkedin, Mail, MapPin, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2d2926] py-16 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img src="https://static.prod-images.emergentagent.com/jobs/88bcfbb5-0f75-48df-9f1d-e41b46909d27/images/0eeae0691aca1cf5f4955a37311e488c07d17393c92e24100575d147c858c8fc.png" alt="Logo" className="w-9 h-9 object-contain" />
              <div className="flex flex-col">
                <span className="font-bold tracking-tight text-xl text-white" style={{ fontFamily: 'Fraunces, serif' }}>Bharat<span className="text-[#2a9d8f]">Intelli</span>AI</span>
                <span className="text-[8px] text-[#8a8078] tracking-wide leading-none">A brand of Rewat Intelliforge Technologies LLP</span>
              </div>
            </div>
            <p className="text-sm text-[#8a8078] mt-3 max-w-sm leading-relaxed">
              Making AI practical, affordable, and accessible for every business, corporate, and public sector organization across India and internationally.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="http://www.linkedin.com/in/rewatraj" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin"
                className="w-9 h-9 rounded-full border border-[#4a453f] flex items-center justify-center text-[#8a8078] hover:text-[#2a9d8f] hover:border-[#2a9d8f]/30 transition-all"><Linkedin size={16} /></a>
              <a href="mailto:contact@bharatintelliai.com" data-testid="footer-email"
                className="w-9 h-9 rounded-full border border-[#4a453f] flex items-center justify-center text-[#8a8078] hover:text-[#2a9d8f] hover:border-[#2a9d8f]/30 transition-all"><Mail size={16} /></a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2.5">
              {["Vision", "Case Studies", "Blog", "FAQ", "Our Products", "Contact"].map((link) => (
                <a key={link} href={`#${link.toLowerCase().replace(/\s/g, '-')}`} className="text-sm text-[#8a8078] hover:text-[#2a9d8f] transition-colors">{link}</a>
              ))}
            </nav>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2"><MapPin size={14} className="text-[#5c564e] mt-0.5 flex-shrink-0" /><p className="text-sm text-[#8a8078]">Patna & Bengaluru, India</p></div>
              <div className="flex items-start gap-2"><Globe size={14} className="text-[#5c564e] mt-0.5 flex-shrink-0" /><p className="text-sm text-[#8a8078]">Global Delivery — serving organizations in India and internationally, remotely and on-site</p></div>
              <div className="flex items-start gap-2"><Mail size={14} className="text-[#5c564e] mt-0.5 flex-shrink-0" /><p className="text-sm text-[#8a8078]">contact@bharatintelliai.com</p></div>
              <p className="text-xs text-[#5c564e] mt-2">Engagements accepted in INR and USD</p>
            </div>
          </div>
        </div>
        <div className="border-t border-[#4a453f] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#5c564e]">&copy; {new Date().getFullYear()} BharatIntelliAI. All rights reserved.</p>
          <p className="text-xs text-[#4a453f]">AI is the tool. Domain expertise is the Moat.</p>
        </div>
      </div>
    </footer>
  );
}
